<template>
  <div class="no-ui-slider">
    <div class="no-ui-slider__headline">
      <UiText
        class="no-ui-slider__text"
        font="components-button-medium"
        :text="`${formatNumberFilter(value[0], { format: 'balance' })}`"
        bold
        color="typography-title01"
      />

      <UiText
        class="no-ui-slider__text"
        font="components-button-medium"
        :text="`${formatNumberFilter(value[1], { format: 'balance' })}`"
        bold
        color="typography-title01"
      />
    </div>
    <div :ref="name" />
  </div>
</template>

<script>
// https://refreshless.com/nouislider/
import noUiSlider from 'nouislider'
import { formatNumberFilter } from '@/util/helpers/vueFilters'

export default {
  name: 'NoUiSlider',
  props: {
    name: { type: String, required: true },
    min: { type: Number, required: true },
    max: { type: Number, required: true },
    step: { type: Number, required: true },
    start: { type: [ Array ], required: true },
    half: { type: [ Array ], required: true },
  },
  data() {
    return {
      slider: null,
      value: [],
    }
  },
  computed: {
    isMultiple() {
      return Array.isArray(this.start)
    },
    defaultSliderOptions() {
      if (this.isMultiple) {
        return {
          start: [...this.start],
          connect: true,
        }
      }

      return {
        start: this.start,
        connect: [true, false],
      }
    },
    sliderRef() {
      return this.$refs[this.name]
    },
  },
  watch: {
    start: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal[0] === oldVal[0] && newVal[1] === oldVal[1]) return

        this.updateSlider()
      },
    },
  },
  mounted() {
    this.initSlider()
  },
  methods: {
    formatNumberFilter,
    initSlider() {
      const opt = this.defaultSliderOptions

      this.slider = noUiSlider.create(this.sliderRef, {
        ...opt,
        step: this.step,
        range: {
          min: this.min,
          ...(this.half && { '50%': this.half }),
          max: this.max,
        },
      })

      this.sliderRef.noUiSlider.on('set', this.updateValue)
      this.sliderRef.noUiSlider.on('slide', this.updateValue)
      this.value = [this.min, this.min]
    },
    updateSlider() {
      const opt = this.defaultSliderOptions

      this.sliderRef.noUiSlider?.updateOptions({
        ...opt,
      })
    },
    updateValue(values) {
      this.value = [parseFloat(values[0]), parseFloat(values[1])]
      this.$emit('input', this.value)
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
